import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { useCookies } from 'react-cookie';
import { 
    Flex, Box, Heading, FormControl, FormLabel, Input, Button, ButtonGroup, Text,
    InputGroup, InputRightElement, InputRightAddon, Icon, IconButton, Center, Select,
    Table, Thead, Tbody, Tfoot, Tr, Th, Td, TableCaption, TableContainer, useDisclosure
} from '@chakra-ui/react';
import ReactPaginate from 'react-paginate';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/ReactToastify.css';
import { MdAddCircleOutline, MdEdit, MdDeleteForever, MdFileOpen, MdInput, MdOutput, MdHistory } from 'react-icons/md';
import { BsArrowLeftCircle, BsArrowRightCircle, } from 'react-icons/bs';
import { FaFileExport } from 'react-icons/fa';

import { FormattedDate, FormattedTime, FormattedNumber } from 'react-intl';
import { withNamespaces } from 'react-i18next';

import { SUCCESS_STATUS, FAILED_STATUS } from '../../../constants';
import "../../../styles/index.scss";

import { 
    apiLoadListMedicine, apiLoadAMedicine, apiCreateNewMedicine, apiUpdateAMedicine, apiDeleteAMedicine, 
    apiLoadListMedicineImportExportByMedicineId, apiCreateNewMedicineImportExport, apiUpdateAMedicineImportExport, 
    apiExportMedicineListToCSV, apiExportMedicineListToExcel
} from '../../../redux/apis/MedicineApis';
import { clearAMedicineDetail, clearMedicineActionStatus, clearMedicineListRemoteCSV,clearMedicineListRemoteExcel } from '../../../redux/actions';
import { 
    getMedicineList, getAMedicine, getMedicineActionStatus, getMedicineActionMsg, getMedicineError, 
    getMedicineTotalCount, getMedicineOffset, getMedicineImportExportList, 
    getMedicineListRemoteCSV, getMedicineListRemoteExcel
} from '../../../redux/selectors';

import NoDataPage from '../../../components/NoData';
import AddEditMedicineModal from '../Modals/AddEditMedicineModal';
import AddEditMedicineImportExportModal from '../Modals/AddEditMedicineImportExportModal';
import ImportExcelMedicineModal from '../Modals/ImportExcelMedicineModal';
import MedicineHistoryModal from '../Modals/MedicineHistoryModal';
import { displayConfirmChoiceAlert } from '../../utils';

function Medicine({ 
    medicineList, medicineDetail, actionStatus, actionMsg, error,
    totalCount, offset, medicineImportExportList, remoteCSV, remoteExcel,
    clearAMedicineDetail, clearMedicineActionStatus, clearMedicineListRemoteCSV, clearMedicineListRemoteExcel,
    apiLoadListMedicine, apiLoadAMedicine, apiCreateNewMedicine, apiUpdateAMedicine, apiDeleteAMedicine,
    apiCreateNewMedicineImportExport, apiUpdateAMedicineImportExport, apiLoadListMedicineImportExportByMedicineId, 
    apiExportMedicineListToCSV, apiExportMedicineListToExcel, t
}) {
    const [ cookies ] = useCookies(["loginCookie"]);
    const [ searchText, setSearchText ] = useState("");
    const [ isSearching, setIsSearching ] = useState(false);
    const [ selectedMedicineId, setSelectedMedicineId ] = useState(null);
    const [ selectedMedicineName, setSelectedMedicineName ] = useState(null);
    const [ exportFileType, setExportFileType ] = useState("EXCEL");
    const [ isImport, setIsImport ] = useState(true);
    const [ isAction, setIsAction ] = useState(false);

    const addEditMedicineModal = useDisclosure();
    const addEditMedicineImportExcelModal = useDisclosure();
    const addEditMedicineImportExportModal = useDisclosure();
    const addEditMedicineHistoryModal = useDisclosure();

    const initialRef = useRef(null);
    const mounted = useRef();
    const limit = 10;
    const pageCount =  Math.ceil(totalCount / limit);

    useEffect(() => {
        if(!mounted.current) {
            apiLoadListMedicine({ company_id: cookies?.loginCookie?.data?.company_id, limit, offset: 0 });
            setIsAction(cookies.loginCookie?.data?.roles === "admin" || cookies.loginCookie?.data?.roles === "super_admin");
            mounted.current = true;
        } else {
            if(actionStatus === SUCCESS_STATUS) {
                if(addEditMedicineModal.isOpen) {
                    addEditMedicineModal.onClose();
                }
                toast.success(actionMsg, {
                    position: "bottom-right"
                });
                clearMedicineActionStatus();
            } 
            else if(actionStatus === FAILED_STATUS) {         
                toast.error(error, {
                    position: "bottom-right"
                });
                clearMedicineActionStatus();
            }
        }
    });

    useEffect(() => {
        setIsSearching(false);
    }, [medicineList]);

    useEffect(() => {
        if (remoteCSV){
            const blobCSV = new Blob([remoteCSV], {type: 'text/csv;charset=UTF-8'});
            //Build a URL from the file
            const fileURL = window.URL.createObjectURL(blobCSV);
            const link = document.createElement('a');
            link.href = fileURL;
            link.setAttribute("download", `${cookies?.loginCookie?.data?.companyDetail?.name + "_DanhMucThuoc"}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            clearMedicineListRemoteCSV();
        }
    }, [remoteCSV]);

    useEffect(() => {
        if (remoteExcel){
            const blobEXCEL = new Blob([remoteExcel], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;'});
            //Build a URL from the file
            const fileURL = window.URL.createObjectURL(blobEXCEL);
            const link = document.createElement('a');
            link.href = fileURL;
            link.setAttribute("download", `${cookies?.loginCookie?.data?.companyDetail?.name + "_DanhMucThuoc"}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            clearMedicineListRemoteExcel();
        }
    }, [remoteExcel]);

    const handleAddNewMedicine = () => {
        clearAMedicineDetail();
        addEditMedicineModal.onOpen();
    }

    const handleUpdateAMedicine = (medicine_id) => {
        apiLoadAMedicine({ id: medicine_id });
    }

    const handleDeleteAMedicine = (medicine_id) => {
        displayConfirmChoiceAlert('Bạn có muốn xoá mã Thuốc này không?', () => {
            apiDeleteAMedicine({ 
                id: medicine_id, 
                payload: { 
                    company_id: cookies?.loginCookie?.data?.company_id,  
                    user_id: cookies?.loginCookie?.data?.id,  
                    is_active: false 
                } 
            });
        });
    }

    const handleExportFile = () => {
        displayConfirmChoiceAlert(`Bạn có muốn xuất dữ liệu ra file ${exportFileType}`, () => {
            if(exportFileType === "CSV") {
                apiExportMedicineListToCSV({ 
                    company_id: cookies?.loginCookie?.data?.company_id,
                    user_id: cookies?.loginCookie?.data?.id,   
                });
            } else if(exportFileType === "EXCEL") {
                apiExportMedicineListToExcel({ 
                    company_id: cookies?.loginCookie?.data?.company_id,
                    user_id: cookies?.loginCookie?.data?.id,   
                });
            } 
        })
    }

    const handleImportDataFinished = () => {
        apiLoadListMedicine({ company_id: cookies?.loginCookie?.data?.company_id, limit, offset: 0 });
    }

    return (
        <React.Fragment>
            <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} borderBottomWidth="2px" px={8} py={4} gap={2} justify="space-between">
                <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} gap={2}>
                    <Button colorScheme='orange' isDisabled={!isAction} onClick={handleAddNewMedicine}>
                        <Icon boxSize={6} as={MdAddCircleOutline} marginRight="8px"/>   
                        <Text fontSize="14px" fontWeight="400" textTransform="uppercase">{t("Add")}</Text>
                    </Button>

                    <Button colorScheme='teal' isDisabled={!isAction}
                        onClick={() => addEditMedicineImportExcelModal.onOpen()}
                    >
                        <Icon boxSize={6} as={MdFileOpen} marginRight="8px"/>   
                        <Text fontSize="14px" fontWeight="400" textTransform="uppercase">{t("Import_Data_From_File")}</Text>
                    </Button>

                    <InputGroup maxW="250px">
                        <Button paddingRight={1} borderTopRightRadius={0} borderBottomRightRadius={0} isDisabled={!isAction}
                             onClick={() => handleExportFile()}
                        >
                            <Icon boxSize={6} as={FaFileExport} marginRight="8px"/>  
                            <Text fontSize="14px" fontWeight="400" textTransform="uppercase">{t("Export_File")}</Text>
                        </Button>
                        <InputRightAddon p={0}>
                            <Select value={exportFileType} borderTopLeftRadius={0} borderBottomLeftRadius={0} isDisabled={!isAction}
                                onChange={(evt) => setExportFileType(evt.currentTarget.value)}
                            >
                                <option value="EXCEL">EXCEL</option>
                                <option value="CSV">CSV</option>
                            </Select>
                        </InputRightAddon>
                    </InputGroup>
                </Flex>

                <InputGroup width={{base: "100%", md: "40%", lg: "40%"}}>
                    <Input placeholder={t("Type_Search_Text")} onChange={(evt) => setSearchText(evt.currentTarget.value)} onKeyUp={(evt) => {
                        if(evt.key === "Enter") {
                            setIsSearching(true);
                            setTimeout(() => {
                                apiLoadListMedicine({ searchText, company_id: cookies?.loginCookie?.data?.company_id });
                            }, 500);
                        }
                    }}/>
                    <InputRightAddon p={0}>
                        <Button colorScheme='blue' 
                            isLoading={isSearching}
                            loadingText={t("Searching")}
                            onClick={() => {
                                setIsSearching(true);
                                setTimeout(() => {
                                    apiLoadListMedicine({ searchText, company_id: cookies?.loginCookie?.data?.company_id });
                                }, 500);
                            }
                        }>
                            {t("Search")}
                        </Button>
                    </InputRightAddon>
                </InputGroup>
            </Flex>
            
            <PaginatedItems 
                company_id={cookies?.loginCookie?.data?.company_id} isAction={isAction} t={t}
                items={medicineList} itemsPerPage={limit} itemOffset={offset} pageCount={pageCount} 
                onOpenMedicineModal={addEditMedicineModal.onOpen} onOpenMedicineImportExportModal={addEditMedicineImportExportModal.onOpen} 
                onOpenMedicineHistoryModal={addEditMedicineHistoryModal.onOpen} 
                setSelectedMedicineId={setSelectedMedicineId} setSelectedMedicineName={setSelectedMedicineName} setIsImport={setIsImport}
                handleUpdateAMedicine={handleUpdateAMedicine} handleDeleteAMedicine={handleDeleteAMedicine}
                apiLoadListMedicine={apiLoadListMedicine} apiLoadListMedicineImportExportByMedicineId={apiLoadListMedicineImportExportByMedicineId}                         
            />

            {
                !(medicineList && medicineList.length > 0) && <NoDataPage text="Hiện tại không có dữ liệu"/>
            }
            
            {
                addEditMedicineModal.isOpen &&
                <AddEditMedicineModal 
                    initialRef={initialRef} isAction={isAction} isOpen={addEditMedicineModal.isOpen} onClose={addEditMedicineModal.onClose} 
                    company_id={cookies?.loginCookie?.data?.company_id} medicineDetail={medicineDetail} actionStatus={actionStatus}
                    apiCreateNewMedicine={apiCreateNewMedicine} apiUpdateAMedicine={apiUpdateAMedicine}
                />
            }
            {
                addEditMedicineImportExportModal.isOpen &&
                <AddEditMedicineImportExportModal 
                    initialRef={initialRef} isOpen={addEditMedicineImportExportModal.isOpen} onClose={addEditMedicineImportExportModal.onClose} 
                    company_id={cookies?.loginCookie?.data?.company_id} medicine_id={selectedMedicineId} isImport={isImport} actionStatus={actionStatus}
                    apiCreateNewMedicineImportExport={apiCreateNewMedicineImportExport} apiUpdateAMedicineImportExport={apiUpdateAMedicineImportExport}
                />
            }
                {
                addEditMedicineHistoryModal.isOpen &&
                <MedicineHistoryModal 
                    initialRef={initialRef} isOpen={addEditMedicineHistoryModal.isOpen} onClose={addEditMedicineHistoryModal.onClose} 
                    company_id={cookies?.loginCookie?.data?.company_id} medicine_name={selectedMedicineName} medicineImportExportList={medicineImportExportList}
                />
            }
            {
                addEditMedicineImportExcelModal.isOpen &&
                <ImportExcelMedicineModal 
                    initialRef={initialRef} isOpen={addEditMedicineImportExcelModal.isOpen} onClose={addEditMedicineImportExcelModal.onClose} 
                    company_id={cookies?.loginCookie?.data?.company_id} onImportDataFinished={handleImportDataFinished}
                />
            }
            <ToastContainer />
        </React.Fragment>
    )
}

function PaginatedItems({ 
    company_id, isAction, items, itemsPerPage, itemOffset, pageCount, t,
    onOpenMedicineModal, onOpenMedicineImportExportModal, onOpenMedicineHistoryModal, 
    setSelectedMedicineId, setSelectedMedicineName, setIsImport,
    apiLoadListMedicine, handleUpdateAMedicine, handleDeleteAMedicine,
    apiLoadListMedicineImportExportByMedicineId
}) {
    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage);
        apiLoadListMedicine({ company_id, limit: itemsPerPage, offset: newOffset });
    } 

    return (
        <>
            <TableContainer width="100%" px="20px" py="5px">
                <Table variant="simple" size="sm">
                    <Thead>
                        <Tr bg="#EAF0F0">
                            <Th>{t("Index")}</Th>
                            <Th>{t("Medicine_Group")}</Th>
                            <Th>{t("Code")}</Th>
                            <Th>{t("Name")}</Th>
                            <Th>{t("Unit")}</Th>
                            <Th>{t("Price")}(VNĐ)</Th>
                            <Th>{t("Default_One_Day")}</Th>
                            <Th>{t("Usage")}</Th>
                            <Th>{t("Quantity")}</Th>
                            <Th>{t("Created_At")}</Th>
                            <Th>{t("Edited_At")}</Th>
                            <Th isNumeric></Th>
                            <Th isNumeric></Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {
                            items && items.map((item, idx) => {
                                return (
                                    <Tr key={item.id}>
                                        <Td>
                                            <Text fontWeight="600">{(itemOffset + idx) + 1}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{item.medicine_group}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{item.code}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{item.name}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{item.unit}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">    
                                                { item.price && <FormattedNumber value={item.price}></FormattedNumber> }
                                            </Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{item.defaultOneDay}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{item.usage}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">
                                                { item.quantity && <FormattedNumber value={item.quantity}></FormattedNumber> }
                                            </Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">
                                                <FormattedDate value={item.created_at} />
                                            </Text>
                                        </Td>
                                        <Td>
                                            {
                                                item.updated_at &&
                                                <Text fontWeight="600">
                                                    <FormattedDate value={item.updated_at} /> <FormattedTime value={item.updated_at} />
                                                </Text>
                                            }
                                        </Td>
                                        <Td isNumeric>
                                            <Flex direction="row" justifyContent="flex-end" alignContent="center">
                                                <Button size="sm" colorScheme='cyan' _hover={{ bg: "#7986cb"}} mr={1}  
                                                    onClick={() => {
                                                        setSelectedMedicineName(item.name);
                                                        onOpenMedicineHistoryModal();
                                                        apiLoadListMedicineImportExportByMedicineId({ id: item.id });
                                                    }}
                                                >
                                                    <Icon boxSize={4} as={MdHistory} marginRight="8px"/>   
                                                    <Text fontSize="14px" fontWeight="400" textTransform="uppercase">{t("Logs")}</Text>
                                                </Button>
                                                <Button size="sm" colorScheme='blue' _hover={{ bg: "#7986cb"}} mr={1} isDisabled={!isAction}
                                                    onClick={() => {
                                                        setSelectedMedicineId(item.id);
                                                        setIsImport(true);
                                                        onOpenMedicineImportExportModal();
                                                    }}
                                                >
                                                    <Icon boxSize={4} as={MdInput} marginRight="8px"/>   
                                                    <Text fontSize="14px" fontWeight="400" textTransform="uppercase">{t("Import")}</Text>
                                                </Button>
                                                <Button size="sm" colorScheme='red' _hover={{ bg: "#7986cb"}} isDisabled={!isAction}
                                                    onClick={() => {
                                                        setSelectedMedicineId(item.id);
                                                        setIsImport(false);
                                                        onOpenMedicineImportExportModal();
                                                    }}
                                                >
                                                    <Icon boxSize={4} as={MdOutput} marginRight="8px"/>   
                                                    <Text fontSize="14px" fontWeight="400" textTransform="uppercase">{t("Export")}</Text>
                                                </Button>
                                            </Flex>
                                        </Td>
                                        <Td isNumeric>
                                            <Flex direction="row" justifyContent="flex-end" alignContent="center" gap={1}>
                                                <IconButton
                                                    title='Sửa'
                                                    icon={<MdEdit />}
                                                    isDisabled={!isAction}
                                                    onClick={() => {
                                                            onOpenMedicineModal();
                                                            handleUpdateAMedicine(item.id);
                                                        }
                                                    }
                                                />
                                                <IconButton
                                                    colorScheme='red'
                                                    title='Xoá'
                                                    icon={<MdDeleteForever />}
                                                    isDisabled={!isAction}
                                                    onClick={() => handleDeleteAMedicine(item.id)}
                                                />
                                            </Flex>
                                        </Td>
                                    </Tr>
                                )
                            })
                        }
                    </Tbody>
                </Table>
            </TableContainer>

            {/* <Flex w="100%" justify="center" my="10px" position={{base: "relative", md: "fixed", lg: "fixed"}} bottom="0px"> */}
                <ReactPaginate 
                    breakLabel="..."
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={2}
                    pageCount={pageCount}
                    previousLabel={
                        <Center>
                            <Icon boxSize={8} as={BsArrowLeftCircle} />
                        </Center>
                    }
                    nextLabel={
                        <Center>
                            <Icon boxSize={8} as={BsArrowRightCircle} />
                        </Center>
                    }
                    renderOnZeroPageCount={null}
                    containerClassName='pagination'
                    pageClassName='page-item'
                    activeClassName='active'
                    previousClassName='previous-item'
                    nextClassName='next-item'
                />
            {/* </Flex> */}
        </>
    )
}

const mapStateToProps = (state) => {
    const medicineList              =   getMedicineList(state);
    const medicineDetail            =   getAMedicine(state);
    const actionStatus              =   getMedicineActionStatus(state);
    const actionMsg                 =   getMedicineActionMsg(state);
    const error                     =   getMedicineError(state);
    const totalCount                =   getMedicineTotalCount(state);
    const offset                    =   getMedicineOffset(state);
    const medicineImportExportList  =   getMedicineImportExportList(state);
    const remoteCSV                 =   getMedicineListRemoteCSV(state);
    const remoteExcel               =   getMedicineListRemoteExcel(state);

    return { medicineList, medicineDetail, actionStatus, actionMsg, error, totalCount, offset, medicineImportExportList, remoteCSV, remoteExcel };
}

const mapDispatchToProps = (dispatch) => ({
    apiLoadListMedicine:         payload => dispatch(apiLoadListMedicine(payload)),
    apiLoadAMedicine:            payload => dispatch(apiLoadAMedicine(payload)),
    apiCreateNewMedicine:        payload => dispatch(apiCreateNewMedicine(payload)),
    apiUpdateAMedicine:          payload => dispatch(apiUpdateAMedicine(payload)),
    apiDeleteAMedicine:          payload => dispatch(apiDeleteAMedicine(payload)),

    apiCreateNewMedicineImportExport:   payload => dispatch(apiCreateNewMedicineImportExport(payload)),
    apiUpdateAMedicineImportExport:     payload => dispatch(apiUpdateAMedicineImportExport(payload)),
    apiExportMedicineListToCSV:         payload => dispatch(apiExportMedicineListToCSV(payload)),
    apiExportMedicineListToExcel:       payload => dispatch(apiExportMedicineListToExcel(payload)),
    apiLoadListMedicineImportExportByMedicineId:   payload => dispatch(apiLoadListMedicineImportExportByMedicineId(payload)),

    clearAMedicineDetail:           payload => dispatch(clearAMedicineDetail(payload)),
    clearMedicineActionStatus:      payload => dispatch(clearMedicineActionStatus(payload)),
    clearMedicineListRemoteCSV:     payload => dispatch(clearMedicineListRemoteCSV(payload)),
    clearMedicineListRemoteExcel:   payload => dispatch(clearMedicineListRemoteExcel(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(Medicine));